function replaceTokens(queryStringTemplate, searchParams) {
    try {
        // when the queryParam is empty we copy non-empty value from the current url
        const templateSearchParams = new URLSearchParams(queryStringTemplate || searchParams);
        const currentPageSearchParams = new URLSearchParams(searchParams);
        const resultSearchParams = new URLSearchParams();
        templateSearchParams.forEach((value, key) => {
            var _a;
            const tokenRegexp = /\{(\w*)\}/;
            // Ref:https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match#using_match
            const token = (_a = value.match(tokenRegexp)) === null || _a === void 0 ? void 0 : _a[1];
            // when not a tokenized value in template, copy existing value
            if (token === undefined) {
                if (value)
                    resultSearchParams.append(key, value);
                return;
            }
            // when token is valid, look up value from current search params and copy
            const valueInCurrentUrl = currentPageSearchParams.get(token);
            if (valueInCurrentUrl) {
                resultSearchParams.append(key, valueInCurrentUrl);
            }
        });
        return resultSearchParams.toString();
    }
    catch (error) {
        return '';
    }
}
export const KEEP_EMPTY_FLAG = 'KEEP_EMPTY_FLAG';
// handles the current impementation, breaking the Sitecore field into an array
const getQueryStringParamsFromCanonicalParamsFieldValue = ({ canonicalProps, searchParams }) => {
    var _a, _b, _c;
    const canonicalParams = (_b = (_a = canonicalProps === null || canonicalProps === void 0 ? void 0 : canonicalProps.canonicalParams) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.split('\r\n');
    if (!Array.isArray(canonicalParams) || !canonicalParams.length || canonicalParams[0] === KEEP_EMPTY_FLAG) {
        return {
            query: '',
            alternateQuery: '',
        };
    }
    const firstEntry = canonicalParams[0] || '';
    const secondEntry = (_c = canonicalParams[1]) !== null && _c !== void 0 ? _c : firstEntry;
    let query = replaceTokens(firstEntry, searchParams) || searchParams || '';
    let alternateQuery = replaceTokens(secondEntry, searchParams) || searchParams || '';
    if (query && !query.startsWith('?'))
        query = `?${query}`;
    if (alternateQuery && !alternateQuery.startsWith('?'))
        alternateQuery = `?${alternateQuery}`;
    return {
        query,
        alternateQuery,
    };
};
const buildAlternatePathFromCanonicalPath = (currentLanguageCode, alternateLanguageCode, pathName) => {
    // only replace language path segment, whether it's embedded in the path string or located at the end of it
    const replaceRegex = new RegExp(`(/${currentLanguageCode}/)|(/${currentLanguageCode}$)`, 'g');
    return (currentLanguageCode &&
        alternateLanguageCode &&
        pathName &&
        pathName.replaceAll(replaceRegex, `/${alternateLanguageCode}/`));
};
/**
 * Gets paths relative to current language setting. \
 * On `/en/...`, the alternate path is the `/fr/...` equivalent, \
 * and vice versa.
 */
export const getLocalePaths = ({ currentLanguageCode, languageSelectors, canonicalProps, searchParams, pathName, }) => {
    var _a, _b, _c;
    const currentLanguageSelector = languageSelectors.find(selector => selector.code === currentLanguageCode);
    const alternateLanguageSelector = languageSelectors.find(selector => selector.code !== currentLanguageCode);
    const { query, alternateQuery } = getQueryStringParamsFromCanonicalParamsFieldValue({
        canonicalProps,
        searchParams,
    });
    const canonicalUrl = ((_a = canonicalProps === null || canonicalProps === void 0 ? void 0 : canonicalProps.canonicalUrl) === null || _a === void 0 ? void 0 : _a.value) || ((pathName === null || pathName === void 0 ? void 0 : pathName.endsWith('/')) ? pathName : currentLanguageSelector === null || currentLanguageSelector === void 0 ? void 0 : currentLanguageSelector.url) || '';
    const alternateUrl = ((_b = canonicalProps === null || canonicalProps === void 0 ? void 0 : canonicalProps.alternateHref) === null || _b === void 0 ? void 0 : _b.value) ||
        (pathName.endsWith('/')
            ? buildAlternatePathFromCanonicalPath(currentLanguageCode, (_c = alternateLanguageSelector === null || alternateLanguageSelector === void 0 ? void 0 : alternateLanguageSelector.code) !== null && _c !== void 0 ? _c : '', pathName)
            : alternateLanguageSelector === null || alternateLanguageSelector === void 0 ? void 0 : alternateLanguageSelector.url) ||
        '';
    return {
        canonicalPath: `${canonicalUrl}${query}`,
        alternatePath: `${alternateUrl}${alternateQuery}`,
    };
};
export const getAlternateLanguageCode = (currentLanguage, languageSelectors) => { var _a; return (_a = languageSelectors.find(selector => selector.code !== currentLanguage)) === null || _a === void 0 ? void 0 : _a.code; };
